<template>
    <div>
        <default-header v-if="flag == 0"></default-header>
        <cei-app-header v-if="flag == 1"></cei-app-header>
    </div>
</template>
<script>

    import DefaultHeader from "./DefaultHeader";
    import {getSystemUnitCode} from '../api/home';
    import CeiAppHeader from "./CeiAppHeader";

    export default {
        name: 'header',
        data() {
            return {
                flag : null,
                height: 65,
            }
        },
        components: {
            CeiAppHeader,
            DefaultHeader,
        },
        created(){
            this.init();
        },
        methods: {
            init(){
                let unitCode = this.$store.getters.unicode;
                if(unitCode != null && unitCode != ''){
                    if(unitCode == "CEI"){
                        this.flag = 1;
                        this.height = 120;
                        this.$emit("init",this.height);
                    }else {
                        this.flag = 0;
                        this.height = 65;
                        this.$emit("init",this.height);
                    }
                }else {
                    getSystemUnitCode().then(res => {
                        this.$store.commit("SET_UNIT_CODE",res.data.data.unitCode);
                        if(res.data.data.unitCode == "CEI"){
                            this.flag = 1;
                            this.height = 120;
                            this.$emit("init",this.height);
                        }else{
                            this.flag = 0;
                            this.height = 65;
                            this.$emit("init",this.height);
                        }
                    }).catch(err => {
                        this.flag = 0;
                        this.height = 65;
                        this.$emit("init",this.height);
                    });
                }
            },
        }
    }
</script>




// WEBPACK FOOTER //
// Header.vue?ce4d71c8